import React from "react";
import { ResponsiveImage } from "@quintype/components";
import { string, array, number, object, func } from "prop-types";

import "./story-card.m.css";

const CustomImageGalleryElement = ({
  className,
  imageAspectRatio,
  defaultWidth,
  element = {},
  widths,
  story,
  onClickHandler
}) => {
  const images = element["story-elements"].map((image, index) => (
    <figure key={image.id} styleName="custom-image">
      <figure
        data-test-id="story-element-image-container"
        className={`story-element-image-gallery__image-container ${onClickHandler ? "custom-cursor" : ""}`}
        onClick={() => onClickHandler && onClickHandler(index)}
      >
        <ResponsiveImage
          slug={image["image-s3-key"]}
          metadata={image["metadata"]}
          aspectRatio={imageAspectRatio || [1, 1]}
          defaultWidth={defaultWidth || 480}
          widths={widths || [250, 480, 640]}
          className={className || "story-element-image-gallery__image"}
          alt={image.title || story.headline}
        />
      </figure>
      <div styleName="name">{image.title}</div>
    </figure>
  ));

  return (
    <div className="story-element-image-gallery" data-test-id="story-element-image-gallery">
      {images}
    </div>
  );
};

CustomImageGalleryElement.propTypes = {
  className: string,
  imageAspectRatio: array,
  defaultWidth: number,
  element: object,
  widths: array,
  story: object,
  onClickHandler: func
};

export default CustomImageGalleryElement;
